/* Illinois-style "Quick Facts" strip — 4-column stat row used across
   entity detail pages (destination / airport / country / aircraft). Each
   fact is an object `{ label, value, hint? }` — hide by passing null. */

export default function EntityQuickFacts({ facts, testid = "entity-quick-facts" }) {
  const shown = (facts || []).filter((f) => f && f.value != null && f.value !== "");
  if (shown.length === 0) return null;
  return (
    <section data-testid={testid}
      className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
      {shown.map((f) => (
        <div key={f.label}
          data-testid={`${testid}-${f.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className="rounded-2xl border border-border bg-card px-4 py-3">
          <div className="text-[10px] font-mono uppercase tracking-[0.15em] text-accent">{f.label}</div>
          <div className="font-serif font-800 text-lg sm:text-xl text-primary leading-tight mt-1 truncate" title={String(f.value)}>{f.value}</div>
          {f.hint && <div className="text-[11px] text-muted-foreground mt-0.5 line-clamp-1">{f.hint}</div>}
        </div>
      ))}
    </section>
  );
}
